import React, { ReactElement } from 'react';
import {
  Box, Checkbox, ListItem, ListItemButton, ListItemIcon,
} from '@mui/material';
import _ from 'lodash';
import { LinkedRecord } from '../shared/material_components/linked-cell';
import { RestApiForm } from '../tasks/types';

export interface Props {
  pickerRecords: Record<string, any>[],
  recordSelection: Record<string, any>,
  handleRecordSelection: (id: string) => void,
  allowMultiple: boolean,
  currentlyLinkedRecords: LinkedRecord[],
  pickerItemView: (record: Record<string, any>, restForm: RestApiForm) => ReactElement,
  restForm: RestApiForm,
}

const RecordPickerItems: React.FC<Props> = ({
  pickerRecords,
  recordSelection,
  allowMultiple,
  handleRecordSelection,
  currentlyLinkedRecords,
  pickerItemView,
  restForm,
}) => {
  const linkedRecords = {};
  if (currentlyLinkedRecords) {
    currentlyLinkedRecords
      .forEach((raw: Record<string, any>) => {
        linkedRecords[raw.id] = {};
      });
  }
  const isItemDisabled = (
    rc: Record<string, any>,
    isMultiple: boolean,
  ) => isMultiple && !_.isEmpty(rc.from) && !linkedRecords[rc.id];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {pickerRecords.map((record: Record<string, any>) => (
        <ListItem key={record.id} disablePadding>
          <ListItemButton
            role={undefined}
            data-testid={record.id}
            disabled={isItemDisabled(record, allowMultiple)}
            selected={!allowMultiple && (recordSelection[record.id]?.selected ?? false)}
            onClick={() => handleRecordSelection(record.id)}
          >
            {allowMultiple && (
              <ListItemIcon>
                <Checkbox
                  disableRipple
                  checked={recordSelection[record.id]?.selected ?? false}
                  data-testid={`checkbox-${record.id}`}
                  name={record.id}
                />
              </ListItemIcon>
            )}
            {
              pickerItemView(record, restForm)
            }
          </ListItemButton>
        </ListItem>
      ))}
    </Box>
  );
};

export default RecordPickerItems;
